import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './TeamRankReportContent.style';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

interface TeamRankReportContentProps {
  tt: (key: string, fallback: string) => string;
  recordData: {
    highestAchievedRank: {description: string};
    certified: boolean;
  };
  renderTitle: () => string;
}

const TeamRankReportContent: React.FC<TeamRankReportContentProps> = ({
  tt = (key, fallback) => fallback, // Default function if tt is not provided
  recordData = {highestAchievedRank: {description: ''}, certified: false}, // Default value for recordData
  renderTitle = () => '', // Default function for renderTitle
}: TeamRankReportContentProps) => {
  const {
    highestAchievedRank: {description: highestAchievedRank},
    certified,
  } = recordData;

  const certifiedText = certified
    ? tt('isCertified', 'Yes')
    : tt('isNotCertified', 'No');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{renderTitle()}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('highestRankAchieved', 'Highest Rank Achieved')}</Text>
          }
          suffix={<Text variant="button">{highestAchievedRank}</Text>}
          testID={CoachInfoCard.harContent}
        />
      </Gutter>
      {FEATURE_FLAGS.showCertificationReference && (
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            readonly={true}
            label={<Text>{tt('certified', 'Certified')}</Text>}
            suffix={<Text variant="button">{certifiedText}</Text>}
            testID={CoachInfoCard.certificationContent}
          />
        </Gutter>
      )}
    </View>
  );
};

export default withTranslation('reportCardContent.teamRank')(
  TeamRankReportContent,
);
